import { AnyAction, combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";

import languageReducer from "./features/languageSlice";
import authReducer from "./features/authSlice";
import bossReducer from "./features/bossSlice";
import grouilleurReducer from "./features/grouilleurSlice";
import sinistreReducer from "./features/sinistreSlice";
import transactionReducer from "./features/transactionSlice";
import promotionReducer from "./features/promotionSlice";
import offreReducer from "./features/offreSlice";
import tacheReducer from "./features/tacheSlice";
import utilisateurReducer from "./features/utilisateurSlice";
import categorieReducer from "./features/categorieSlice";
import superCategorieReducer from "./features/superCategorieSlice";
import uiReducer from "./utils/uiSlice";
import localforage from "localforage";

const appReducer = combineReducers({
  ui: uiReducer,
  language: languageReducer,
  auth: authReducer,
  boss: bossReducer,
  grouilleur: grouilleurReducer,
  sinistre: sinistreReducer,
  transaction: transactionReducer,
  promotion: promotionReducer,
  offre: offreReducer,
  tache: tacheReducer,
  utilisateur: utilisateurReducer,
  categorie: categorieReducer,
  super_categorie: superCategorieReducer,
});

const persistConfig = {
  key: "root",
  storage: localforage,
  // blacklist: ["ui"],
};

const initialState = {
  dossier: {},
  language: {
    systemLanguage: "en",
    languages: [
      {
        lang: "english",
        key: "en",
      },
      {
        lang: "french",
        key: "fr",
      },
    ],
  },
  ui: {
    snackBarVisible: false,
    snackbarUserUi: {
      visible: false,
      message: "",
      color: "",
      icon: "check",
    },
    lang: "en",
    sessionExpired: false,
  },
  user: null,
  auth: {user: null},
  grouilleur: {},
  boss: {},
  sinistre: {},
  transaction: {} as any,
  promotion: {},
  offre: {},
  tache: {},
  utilisateur: {},
  categorie: {},
  super_categorie: {},
};

const rootReducer = (state: any, action: AnyAction) => {
  if (action.type === "USER_LOGGED_OUT") {
    return initialState;
  }
  if (action.type === "RESET_STATE") {
    return { ...initialState, user: state.user };
  }
  return appReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
  devTools: process.env.NODE_ENV !== "production",
});

export type RootState = ReturnType<typeof rootReducer>
export type AppDispatch = typeof store.dispatch

export const persistor = persistStore(store);
